import styled from 'styled-components'
import { getErrorImage } from 'domain/errors'
import { WrapperProps } from 'App/Main/Error/types'

export const LOGO_HEIGHT = '72px'

export const ErrorContainerWrapper = styled.div`
  background: #98d6e5;
  border-top: initial;
  color: ${({ theme }) => theme.colors.text.title};
  height: 100%;
  left: 0;
  min-height: ${window.innerHeight};
  min-width: 100vw;
  padding: ${({ theme }) => theme.space.s300} ${({ theme }) => theme.space.s300} 0;
  position: fixed;
  right: 0;
  text-align: left;
  width: 100%;

  @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
    padding: ${({ theme }) => theme.space.s300} ${({ theme }) => theme.space.s200} 0;
  }

  & .Error__Header {
    display: block;
    height: ${LOGO_HEIGHT};
    margin: 0 auto;
    max-width: 350px;

    & svg {
      display: block;
      height: ${LOGO_HEIGHT};
      margin: 0 auto;
    }

    @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
      display: none;
    }
  }

  & .Error__Content {
    height: 100%;
    margin: 0 auto;
    max-width: 840px;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
      position: relative;
    }

    @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
      height: 100%;
    }
  }
`

export const ErrorMessageWrapper = styled.div<WrapperProps>`
  height: 100%;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    max-height: 800px;
    position: absolute;
    top: 45%;
    transform: translateY(-55%);
  }

  @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
    position: relative;
  }

  & .Error__InformationBlock {
    display: inline-block;
    max-width: 300px;

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
      vertical-align: middle;
    }

    @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
      display: block;
      margin: 0 auto;
      max-width: 100%;
    }
  }

  & .Error__Title {
    /* Font style does not exist on Kawaui theme */
    color:  ${({ theme }) => theme.colors.text.title};
    font-family: ${({ theme }) => theme.typography.heading.heading.fontFamily};
    font-size: 2.625rem;
    font-weight: ${({ theme }) => theme.typography.heading.heading.fontWeight};
    line-height: 3rem;
    padding-bottom: ${({ theme }) => theme.space.s200};
    text-align: left;
  }

  & .Error__SubTitle {
    color: ${({ theme }) => theme.colors.text.title};
    font-family: ${({ theme }) => theme.typography.heading.subheading.fontFamily};
    font-size: ${({ theme }) => theme.typography.heading.subheading.fontSize};
    font-weight: ${({ theme }) => theme.typography.heading.subheading.fontWeight};
    line-height: ${({ theme }) => theme.typography.heading.subheading.lineHeight};
    padding-bottom: ${({ theme }) => theme.space.s200};
    text-align: left;
  }

  & .Error__Sentence {
    margin: 0;
    padding-bottom: ${({ theme }) => theme.space.s400};

    @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
      padding-bottom: ${({ theme }) => theme.space.s300};
    }
  }

  & .Error__WrapperButton {
    display: block;
    text-decoration: none;

    & > button {
      font-family: ${({ theme }) => theme.typography.body.textMain.fontFamily};
      font-size: ${({ theme }) => theme.typography.body.textMain.fontSize};
      font-weight: ${({ theme }) => theme.typography.body.textMain.fontWeight};
      line-height: ${({ theme }) => theme.typography.body.textMain.lineHeight};
      margin: 0;
    }

    & + .Error__WrapperButton {
      padding-top: ${({ theme }) => theme.space.s200};
    }

    @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
      & > button {
        max-width: 100%;
      }
    }
  }

  & .Error__Image {
    background-color: transparent;
    background-image: ${({ partner }) => `url("${getErrorImage(partner)}")`};
    background-position: right;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    width: 55%;

    @media only screen and (max-width: calc(${({ theme }) => theme.breakpoint.desktop} - 1px)) {
      background-position: top;
      background-size: cover;
      bottom: 0;
      height: 40vh;
      left: 0;
      margin: 0 auto;
      max-width: 300px;
      position: absolute;
      right: 0;
      width: 100%;
      z-index: -1;
    }
  }
`
